export enum ProductionStage {
  Queued = 'queued',
  Cutting = 'cutting',
  Design = 'design',
  Embroidery = 'embroidery',
  Trim = 'trim',
  Laundry = 'laundry',
  Sewing = 'sewing',
  Finishing = 'finishing',
  Press = 'press',
  Completed = 'completed',
}

export type ProductionStageMove = 'next' | 'skip' | 'back';

const PRODUCTION_STAGE_ORDER = Object.values(ProductionStage);

export function productionStageMove(
  from: ProductionStage | null,
  to: ProductionStage
): ProductionStageMove {
  const fromIndex = from == null ? -1 : PRODUCTION_STAGE_ORDER.indexOf(from);
  const toIndex = PRODUCTION_STAGE_ORDER.indexOf(to);

  if (fromIndex < 0 || toIndex < 0) {
    return 'skip';
  }
  if (toIndex < fromIndex) {
    return 'back';
  }
  return toIndex === fromIndex + 1 ? 'next' : 'skip';
}
